import {fetch, normalize} from "utils/dataAccess";
import {WmsItemsStatus} from "utils/WmsItemsStatus";
import {WmsContainerType} from "utils/WMSContainerType";

export function getWMSContainers(currentInventoryId, params = null) {
    return new Promise((resolve, reject) => {
        fetch(`/w_m_s_containers?inventoryId=${currentInventoryId}&${params}`)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved['hydra:member'])
                })
            })
            .catch(error => reject(error));
    });
}

export function getWMSTrolleyForPicking(currentInventoryId) {
    return new Promise((resolve, reject) => {
        fetch(`/w_m_s_containers/for_picking?inventoryId=${currentInventoryId}&type[]=${WmsContainerType.TROLLEY}&pagination=false`)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved['hydra:member'])
                })
            })
            .catch(error => reject(error))
    })
}

export function getWMSContainersWithType(type, currentInventoryId, paginate = true) {
    const paginationParam = paginate ? '' : '&pagination=false';
    return new Promise((resolve, reject) => {
        fetch(`w_m_s_containers?type=${type}&inventoryId=${currentInventoryId}${paginationParam}`)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved['hydra:member'])
                })
            })
            .catch(error => reject(error))
    })
}

export function getWMSContainerWithCodeBar(codeBar, canCatch) {

    return new Promise((resolve, reject) => {
        fetch("/w_m_s_containers/" + codeBar, {}, false, true)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}

export function getReadyToBeSortedItem(currentInventory) {
    return new Promise((resolve, reject) => {
        fetch(`/w_m_s_containers/readyToBeSorted?type[]=${WmsContainerType.TROLLEY}&type[]=${WmsContainerType.STACK}&wmsItemStatus=${WmsItemsStatus.READY_TO_BE_SORTED}&inventoryId=${currentInventory.id}`)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved['hydra:member'])
                })
            })
            .catch(error => reject(error))
    });
}

export function patchWMSContainerMemberWithCodebar(codeBar, member) {
    return new Promise((resolve, reject) => {
        fetch("/w_m_s_containers/" + codeBar, {
            method: "PATCH",
            headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
            body: JSON.stringify({
                member: member ? "/members/"+member.id : null
            })
        }, false, true)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(normalize(retrieved))
                })
            })
            .catch(error => reject(error));
    });
}

export function patchWmsContainersWithCodebar(codeBar, values) {
    return new Promise((resolve, reject) => {
        fetch("/w_m_s_containers/" + codeBar, {
            method: "PATCH",
            headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
            body: JSON.stringify(values)
        }, false, true)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(normalize(retrieved))
                })
            })
            .catch(error => reject(error));
    })
}

export function getShipmentsAndStationsToSort(currentInventory) {
    return new Promise((resolve, reject) => {
        fetch("/w_m_s_containers/trolleyAndStationToSort/"+currentInventory.id)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}

export function sortingMassTransfer(fromContainerCodebar, toContainerCodebar, inventoryId, shipments = []) {
    return new Promise((resolve, reject) => {
        fetch("/w_m_s_containers/massTransfer/"+inventoryId, {
            method: "POST",
            headers: new Headers({'Content-Type': 'application/json'}),
            body: JSON.stringify({
                fromContainer: fromContainerCodebar,
                toContainer: toContainerCodebar,
                shipments: shipments
            })
        })
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}
